import * as Helper from "../../constant/reducer_names";
import dashboard from '../slices/dashboard'
import contact from '../slices/contact'

export const DashboardReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.DASHBOARD}/reset`) {
    state = undefined;
  }
  return dashboard(state, action);
};

export const ContactReducerWrapper = (state: any, action: any) => {
  if (action.type === `${Helper.CONTACT}/reset`) {
    state = undefined;
  }
  return contact(state, action);
};
